/* Shared helpers for the Supply › Reports screens. */
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/* Write a simple sheet (header row + array-of-arrays body) to an .xlsx download. */
export const exportToXlsx = (filename, headers, rows, sheetName = "Report") => {
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const out = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([out], { type: "application/octet-stream" }), filename);
};

/* True when `date` (YYYY-MM-DD) falls within an optional [from, to] range. */
export const inDateRange = (date, from, to) => {
  if (!date) return !from && !to;
  if (from && date < from) return false;
  if (to && date > to) return false;
  return true;
};
